import Markdown from "react-markdown";
import { twMerge } from "tailwind-merge";

import { ThumbIcon } from "~/common/components";
import {
  ALL_TREATMENT_RECOMMENDATIONS_CODES,
  PREVIEW_TITLE_CODES,
  TREATMENT_RECOMMENDATIONS_CODES,
} from "~/providers/constants/SummariesExpandableIds";
import {
  HandleRateSummaryProps,
  TreatmentRecommendationsV3 as TreatmentRecommendationsType,
} from "~/providers/utils/types/patientIntakePreviewTypes";
import { SummaryType } from "~/providers/utils/types/patientPreviewTypes";
import Expandable from "../common/Expandable";

interface TreatmentRecommendationsProps {
  treatmentRecommendations: TreatmentRecommendationsType;
  summaryType: SummaryType;
  onRate: (data: HandleRateSummaryProps) => void;
  isLike?: boolean;
  isRatePending?: boolean;
}

const SHOW_PRESCRIBER_CONSIDERATIONS = false;

export const TreatmentRecommendationsV3 = ({
  treatmentRecommendations,
  onRate,
  summaryType,
  isLike,
  isRatePending,
}: TreatmentRecommendationsProps) => {
  const handleRate = (rate: boolean) => {
    if (isLike === rate) return onRate({ isLike: null, summaryType });
    onRate({ isLike: rate, summaryType });
  };

  return (
    <Expandable.Wrapper
      code={PREVIEW_TITLE_CODES.TREATMENT_RECOMMENDATIONS}
      expandableSections={[...ALL_TREATMENT_RECOMMENDATIONS_CODES]}
    >
      <div className="flex flex-col gap-4 text-gray-70">
        <Expandable.Section
          code={TREATMENT_RECOMMENDATIONS_CODES.COGNITIVE_BEHAVIORAL_THERAPY}
        >
          {treatmentRecommendations.cognitive_behavioral_therapy}
        </Expandable.Section>
        <Expandable.Section
          code={TREATMENT_RECOMMENDATIONS_CODES.INSIGHT_ORIENTED_THERAPY}
          className={twMerge(
            !SHOW_PRESCRIBER_CONSIDERATIONS && "border-none pb-0",
          )}
        >
          {treatmentRecommendations.insight_oriented_therapy}
        </Expandable.Section>
        {SHOW_PRESCRIBER_CONSIDERATIONS && (
          <Expandable.Section
            code={TREATMENT_RECOMMENDATIONS_CODES.PRESCRIBER_CONSIDERATIONS}
            className="border-none pb-0"
          >
            <div className="flex flex-col gap-2">
              <Markdown>
                {treatmentRecommendations.prescriber_considerations}
              </Markdown>
              <div className="flex flex-row gap-2">
                <button
                  disabled={isRatePending}
                  onClick={() => handleRate(true)}
                >
                  <ThumbIcon
                    className={twMerge(
                      "size-4",
                      isLike && "fill-primary-500 text-primary-500",
                    )}
                  />
                </button>
                <button
                  disabled={isRatePending}
                  onClick={() => handleRate(false)}
                >
                  <ThumbIcon
                    isDown
                    className={twMerge(
                      "size-4",
                      isLike === false && "fill-primary-500 text-primary-500",
                    )}
                  />
                </button>
              </div>
            </div>
          </Expandable.Section>
        )}
      </div>
    </Expandable.Wrapper>
  );
};
